<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-menu
    v-model="startEndTimeOpen"
    :max-width="520"
    :min-width="520"
    :close-on-content-click="false"
    :content-class="isPopup ? 'UXDatapicker timePicker fixedPicker' : 'UXDatapicker timePicker'"
    :disabled="dis"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdatetimeInput outline" :class="{ disabled: dis }" v-on="on">
        <span class="inpTxt" v-if="picker !== ''">{{ picker }}</span>
        <span class="inpTxt gray-6--text" v-else>시작시간 - 종료시간</span>
        <i class="UXicon-down"></i>
      </div>
    </template>

    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong>
            <span v-if="startHour || startMinute || endHour || endMinute">
              {{ startHour ? startHour + ' :' : '00 :' }}
              {{ startMinute ? startMinute : '00' }}
              ~
              {{ endHour ? endHour + ' :' : '00 :' }}
              {{ endMinute ? endMinute : '00' }}
            </span>
            <span v-else>시간선택</span>
          </strong>
        </p>
        <div class="endBtn" v-if="startHour && startMinute && endHour && endMinute">
          <v-btn dark color="#5578F0" @click="setTime">완료</v-btn>
        </div>
      </div>

      <div class="con3">
        <div class="timeBox">
          <div class="startEndHeader">시작시간</div>
          <dl>
            <dd>
              <perfect-scrollbar ref="startHourList">
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a :class="{ on: startHour == item }" @click="startHour = item">{{ item }}시</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dd>
              <perfect-scrollbar ref="startMinuteList">
                <ul v-if="!(startHour === 24 || startHour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{ on: startMinute == item }" @click="startMinute = item">{{ item }}분</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{ on: startMinute == '00' }" @click="startMinute = '00'">00분</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>

        <div class="timeBox">
          <div class="startEndHeader">종료시간</div>
          <dl>
            <dd>
              <perfect-scrollbar ref="endHourList">
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a :class="{ on: endHour == item }" @click="endHour = item">{{ item }}시</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dd>
              <perfect-scrollbar ref="endMinuteList">
                <ul v-if="!(endHour === 24 || endHour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{ on: endMinute == item }" @click="endMinute = item">{{ item }}분</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{ on: endMinute == '00' }" @click="endMinute = '00'">00분</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'StartEndTimePicker',
  data() {
    return {
      startEndTimeOpen: false,
      hours: [],
      minutes: [],
      startHour: '',
      startMinute: '',
      endHour: '',
      endMinute: '',
      picker: ''
    };
  },
  props: {
    startTime: {
      type: String
    },
    endTime: {
      type: String
    },
    minuteScope: {
      type: Number
    },
    dis: {
      type: Boolean
    },
    isPopup: {
      type: Boolean
    }
  },
  created() {
    const minuteScopeNum = !this.minuteScope ? 5 : this.minuteScope < 60 ? this.minuteScope : 5;
    for (let i = 0; i < 60; i++) {
      let num = i.toString().length > 1 ? i : '0' + i.toString();
      if (this.hours.length <= 24 && i >= 0) {
        this.hours.push(num);
      }
      if (i % minuteScopeNum === 0) {
        this.minutes.push(num);
      }
    }
    setTimeout(() => {
      this.resetTime();
    }, 50);
  },
  watch: {
    startTime() {
      this.resetTime();
    },
    endTime() {
      this.resetTime();
    },
    startHour(val) {
      if (Number(val) === 24) {
        this.startMinute = '00';
      }
    },
    endHour(val) {
      if (Number(val) === 24) {
        this.endMinute = '00';
      }
    },
    startEndTimeOpen(val) {
      if (val) {
        setTimeout(() => this.moveScroll(), 300);
      } else {
        this.resetTime();
      }
    }
  },
  methods: {
    initTime() {
      this.picker = '';
      this.startHour = '';
      this.startMinute = '';
      this.endHour = '';
      this.endMinute = '';
    },
    resetTime() {
      if (this.startTime && this.endTime) {
        this.startMinute = this.startTime.split(':')[1] === '59' ? '00' : this.startTime.split(':')[1];
        this.startHour = this.startTime.split(':')[1] === '59' ? Number(this.startTime.split(':')[0]) + 1 : this.startTime.split(':')[0];

        this.endMinute = this.endTime.split(':')[1] === '59' ? '00' : this.endTime.split(':')[1];
        this.endHour = this.endTime.split(':')[1] === '59' ? Number(this.endTime.split(':')[0]) + 1 : this.endTime.split(':')[0];

        this.picker = `${this.startHour}:${this.startMinute} ~ ${this.endHour}:${this.endMinute}`;
      } else {
        this.startHour = '';
        this.startMinute = '';
        this.endHour = '';
        this.endMinute = '';
      }
    },
    moveScroll() {
      const itemSize = 24;

      if (this.startTime) {
        this.$refs.startHourList.$el.scrollTop = this.$refs.startHourList ? Number(this.startHour) * itemSize : 0;
        this.$refs.startMinuteList.$el.scrollTop = this.$refs.startMinuteList ? Math.floor(this.startMinute / 5) * itemSize : 0;
      }
      if (this.endTime) {
        this.$refs.endHourList.$el.scrollTop = this.$refs.endHourList ? Number(this.endHour) * itemSize : 0;
        this.$refs.endMinuteList.$el.scrollTop = this.$refs.endMinuteList ? Math.floor(this.endMinute / 5) * itemSize : 0;
      }
    },
    setTime() {
      if (Number(this.startHour) === Number(this.endHour) && Number(this.startMinute) === Number(this.endMinute)) {
        this.resetTime();
        this.$alertMsg('시작시간과 종료시간이 같습니다.');
        return false;
      } else if (
        Number(this.startHour) - Number(this.endHour) > 0 ||
        (Number(this.startHour) - Number(this.endHour) === 0 && Number(this.startMinute) - Number(this.endMinute) > 0)
      ) {
        this.resetTime();
        this.$alertMsg('시작시간이 종료시간보다 늦을 수 없습니다.');
        return false;
      }
      let time = {
        start: `${this.startHour}:${this.startMinute}:00`,
        end: `${this.endHour}:${this.endMinute}:00`
      };
      this.$emit('child', time);
      this.picker = `${this.startHour}:${this.startMinute}` + ' ~ ' + `${this.endHour}:${this.endMinute}`;
      this.startEndTimeOpen = false;
    }
  }
};
</script>

<style lang="scss">
.timePicker .UXdtpCard .con3 .timeBox dl dd ul {
  padding-bottom: 0;
}
.fixedPicker {
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/StartEndTimePicker.vue